import React from 'react'
import { Stack, Typography } from '@mui/material'
import CheckCircleOutline from '@mui/icons-material/CheckCircleRounded'
import { ContentBox, StyledCard } from './oauth-integration-connected-card-styles'

export type OAuthIntegrationConnectedCardProps = {
	title: string,
}
export const OAuthIntegrationConnectedCard = ( { title }: OAuthIntegrationConnectedCardProps ) => {
	return (
		<StyledCard>
			<Stack direction="row" spacing={1} alignItems="center">
				<CheckCircleOutline color="success" fontSize="medium" />
				<ContentBox>
					<Typography variant="h4">
						{title}
					</Typography>
				</ContentBox>
			</Stack>
		</StyledCard>
	)
}
